const selectors = document.querySelectorAll('.rit-select');

selectors.forEach( (select) => {
    const open = select.querySelector('.rit-select__selected');
    const options = select.querySelector('.rit-select__options');
    open.addEventListener('click', () => {
        options.classList.toggle('active');
    })

    const list = options.querySelectorAll('li');
    const filter = options.querySelector('#search_list');

    if( filter ) {
        filter.addEventListener('input', () => {
            list.forEach( (item) => { 
                if( item.innerText.toLowerCase().includes( filter.value.toLowerCase() ) ) {
                    item.style.display = "block";
                }
                else {
                    item.style.display = "none";
                }
            })
        })
    }

    list.forEach((option) => {
        option.addEventListener('click', () => {
            const val = option.dataset.value;
            const text = option.innerText;

            open.dataset.value = val;
            open.innerText = text;
            options.classList.remove('active');
        })
    })
})